import React, { useState, useContext, useRef, useEffect, forwardRef, useImperativeHandle, useLayoutEffect } from "react";

import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
// import { RadioButton } from "primereact/radiobutton";
// import { InputText } from "primereact/inputtext";
// import { TabView, TabPanel } from "primereact/tabview";

import GlobalContext from "../../../contexto/GlobalContext";
// import EliminarVentana from "../../../../../isp._iu.start.principal/reductores/acciones/widgets/EliminarVentana";
// import PosicionarVentanaTop from "../../../../../isp._iu.start.principal/reductores/acciones/widgets/PosicionarVentanaTop";
// import OrigenTypes from "../../reductores/OrigenTypes";
// import ActionTypesWidgets from "../../reductores/ActionTypesWidgets";

// export default function Dialogo({ ventana, cabecera, pie, estilo, modal, posicionZ, children }) {
// const Dialogo = (({ ventana, cabecera, pie, estilo, modal, posicionZ, children }) => {
const Dialogo = forwardRef(({ ventana, cabecera, pie, estilo, modal, posicionZ, children }, ref) => {
    // const { dispatchPrincipal } = useContext(GlobalContext);
    const { posicionarVentanaTop, eliminarVentana } = useContext(GlobalContext);
    // const [nroRenderizados, forceUpdateRenderizados] = useState(0);
    // const [posicionX, SetPosicionX] = useState(0);
    // const [posicionY, SetPosicionY] = useState(0);

    const refDialog = useRef(null);
    useImperativeHandle(ref, ()=>{
        requestAnimationFrame(() => {
            const rect = refDialog.current.dialogRef.current.getBoundingClientRect();
            ref.current.xDialogo=rect.x;
            ref.current.yDialogo=rect.y;
        });     
        return {xDialogo: 0, yDialogo: 0};
    });
    // ref.current=dialogRef.current;
    // console.log("ventana dialogo ",ventana);
    // if (nroRenderizados === 0) {
        // console.log(ventana.posicionZ);
        // ventana.posicionZ--;
        // ventana.posicionZ=5;
        // ventana.posicionZ=ventana.posicionZ-1;
        // posicionZ--;
    // }

    useEffect(() => {
        console.log("entro");
        // const rect2 = ref.current.getBoundingClientRect();
        // ventana.posicionZ=dialogRef.current.mask.zIndex;
        // ref.current.mask.style.zIndex=ventana.posicionZ;
        requestAnimationFrame(() => {
            // ref.current.mask.style.zIndex=ventana.posicionZ;
            refDialog.current.mask.style.zIndex=ventana.posicionZ;
            
            // ventana.posicionZ=dialogRef.current.mask.style.zIndex;
        });
    }, []);

    /* useLayoutEffect(() => {
        ventana.posicionZ=dialogRef.current.mask.zIndex;
    }, []); */

    const onShow = () => {
        // console.log("onShow");
        // forceUpdateRenderizados((x) => x + 1);
        // setPosicionZ(posicionZ+1);
        // dialogoPrime.current.maskStyle={zIndex: ventana.posicionZ}
        // console.log('dialogoPrime: ',dialogoPrime.current.maskStyle);

    };

    const onClick = (eventoSynDom) => {
        // dispatchPrincipal(new PosicionarVentanaTop(ventana));
        posicionarVentanaTop(ventana)
        // eventoSynDom.stopPropagation();
        // console.log(eventoSynDom);
    };
    
    const clickCerrar = (eventoSynDom) => {
        eliminarVentana(ventana);
        // dispatchPrincipal(new EliminarVentana(ventana));
        // eventoSynDom.stopPropagation();
    };

    const clickMinimizar = (eventoSynDom) => {
        eliminarVentana(ventana);
        // dispatchPrincipal(new EliminarVentana(ventana.id));
        // dispatchPrincipal(new EliminarVentana(ventana));
        // eventoSynDom.stopPropagation();

    };

    const cabeceraDialogo = (
        <div className="flex justify-between">
            {cabecera.elementoReact}
            <div className="flex items-center">
                <Button
                    icon="pi pi-window-minimize"
                    className="p-button-rounded p-button-help p-button-outlined mr-1.5 w-9 h-9"
                    aria-label="Cancel"
                    onClick={clickMinimizar}
                    disabled={cabecera.enProgreso}
                />
                <Button
                    icon="pi pi-times"
                    className="p-button-rounded p-button-help p-button-outlined  w-9 h-9"
                    aria-label="Cancel"
                    onClick={clickCerrar}
                    disabled={cabecera.enProgreso}
                />
            </div>
        </div>
    );

    return (
        <Dialog
            // ref={funcionRef}
            /* ref={(el)=>{
                console.log("ref ",ref)
                if(el){
                    ref.current=el;
                }else{
                    return null;
                }
                    
                // dialogRef.current=el;
            }} */
            ref={refDialog}
            modal={modal}
            header={cabeceraDialogo}
            visible={true}
            style={estilo}
            // modal={false}
            footer={pie}
            // onHide={(eventoDom) => onClick("CERRAR_DIALOGO", eventoDom)}
            onShow={onShow}
            onClick={onClick}
            // onClick={(eventoDom) => onClick("CLICK_PANEL", eventoDom)}
            keepInViewport={false}
            maskStyle={{zIndex: `${posicionZ}`}}
            closable={false}
            position={"top"}
            // baseZIndex={1000}
            // className="top-1/8"
        >
            {children}
        </Dialog>
    );
});

export default Dialogo;
